import { z } from 'zod';

export const idTokenSchema = z.object({
    email: z.string().email(),
    name: z.string(),
    exp: z.number(),
});
